import React from 'react';
import { makeStyles, FormControl, MenuItem, Checkbox, ListItemText } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { Select } from 'formik-material-ui';
import { Field, useField } from 'formik';
import { DropDownIcon } from '../Images/Icons';

const useStyles = makeStyles({
    rootFormControl: (props) => ({
        direction: props.dynamic ? 'ltr' : 'inherit',
        textAlign: props.dynamic ? 'left' : 'inherit',
        width: props.dynamic ? '100%' : '180px',
        paddingLeft: props.dynamic || props.width === '100%' ? '0' : '30px',
        paddingBottom: '26px'
    }),
    label: {
        paddingBottom: '8px',
        color: '#767676'
    },
    select: {
        backgroundColor: 'white',
        border: '1px solid #bbbbbb',
        borderRadius: '9px',
        lineHeight: '1.67em',
        height: '1.67em',
        '&:focus': {
            borderRadius: '9px',
            backgroundColor: 'white'
        }
    },
    icon: (props) => ({
        position: 'absolute',
        left: props.dynamic ? 'auto' : '12px',
        right: props.dynamic ? '12px' : 'auto',
        pointerEvents: 'none'
    }),
    menuItemRoot: (props) => ({
        textAlign: props.dynamic ? 'left' : 'right',
        direction: props.dynamic ? 'ltr' : 'rtl'
    })
});
export default function MultiSelect(props) {
    const classes = useStyles(props);
    const [field] = useField(props);
    return (
        <FormControl classes={{ root: classes.rootFormControl }}>
            {props.dynamic ? (
                <label
                    dangerouslySetInnerHTML={{ __html: props.label }}
                    className={classes.label}
                    htmlFor={props.id || props.name}
                ></label>
            ) : (
                <label className={classes.label} htmlFor={props.id || props.name}>
                    {props.label}
                </label>
            )}
            <Field
                {...field}
                value={field.value ? field.value : []}
                component={Select}
                inputProps={{
                    multiple: true,
                    className: classes.select
                }}
                renderValue={(selected) => selected.join(', ')}
                IconComponent={() => (
                    <DropDownIcon className={classes.icon} height="24" width="24" fill="#bbb" />
                )}
            >
                {props.selectItems?.map((item, index) => (
                    <MenuItem
                        classes={{ root: classes.menuItemRoot }}
                        key={index}
                        value={props.valuePropName ? item[props.valuePropName] : item}
                    >
                        <Checkbox
                            color="primary"
                            checked={
                                field.value?.indexOf(
                                    props.valuePropName ? item[props.valuePropName] : item
                                ) > -1
                            }
                        />
                        <ListItemText
                            primary={props.labelPropName ? item[props.labelPropName] : item}
                        />
                    </MenuItem>
                ))}
            </Field>
        </FormControl>
    );
}
MultiSelect.propTypes = {
    id: PropTypes.any,
    name: PropTypes.string,
    label: PropTypes.string,
    selectItems: PropTypes.array,
    valuePropName: PropTypes.string,
    labelPropName: PropTypes.string,
    setValue: PropTypes.func,
    dynamic: PropTypes.any
};
